import { createSlice } from '@reduxjs/toolkit'

const sliderSlice = createSlice({
    name: 'slider',
    initialState: {
      sliders: [
       
      ]
    }
    ,
    reducers: {
        updateSlides: (state, action) => {
            state.sliders = action.payload;
        }
    }
})

export const {updateSlides} = sliderSlice.actions;
export default sliderSlice.reducer;
